import { render, staticRenderFns } from "./secondary-kpi-lightbox.vue?vue&type=template&id=e606a032"
import script from "./secondary-kpi-lightbox.vue?vue&type=script&lang=ts"
export * from "./secondary-kpi-lightbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e606a032')) {
      api.createRecord('e606a032', component.options)
    } else {
      api.reload('e606a032', component.options)
    }
    module.hot.accept("./secondary-kpi-lightbox.vue?vue&type=template&id=e606a032", function () {
      api.rerender('e606a032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula-step/secondary-kpi-tab/secondary-kpi-lightbox/secondary-kpi-lightbox.vue"
export default component.exports